import { FilterOptionInterface } from "@/interface/app/filter.interface";
import { FilterOptionType } from "@/types/app/filter.type";

export class FilterOption implements FilterOptionInterface {
  contain: string;
  column: string;
  value: string;

  constructor(data: FilterOptionType) {
    this.contain = data.contain || "";
    this.column = data.column || "";
    this.value = data.value || "";
  }
}
